import { FORM_STATES } from '@bingads-webui-fluent-component/form';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';

const DelayedCampaignSettingsStepWithI18n =
  () => import(/* webpackChunkName: 'campaign-settings-step.async' */'./campaign-settings-step')
    .then(({ CampaignSettingsStepWithI18n }) => CampaignSettingsStepWithI18n);

const DelayedCampaignSettingsLazyRepository =
  () => import(/* webpackChunkName: 'campaign-settings-lazy-repository.async' */'./campaign-settings-lazy-repository')
    .then(({ CampaignSettingsLazyRepositoryWithI18n }) => CampaignSettingsLazyRepositoryWithI18n);

export const SearchCampaignSettingsStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.SEARCH_CAMPAIGN_SETTINGS,
  view: DelayedCampaignSettingsStepWithI18n,
  repository: DelayedCampaignSettingsLazyRepository,
  machineOptions: {
    initialState: FORM_STATES.FETCHING,
  },
  viewProps: {
    isSignup: true,
  },
  repositoryProps: {
    isSignup: true,
  },
};
